import { useState, useRef, useEffect } from "react";
import { LogOut, LogIn, ChevronDown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const AuthMenu = ({ mobile = false }) => {
  const { user, login, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  if (!user) {
    return (
      <button
        data-testid={mobile ? "nav-signin-mobile" : "nav-signin"}
        onClick={login}
        className={`inline-flex items-center gap-2 rounded-full border border-white/25 hover:border-white text-white text-sm font-semibold px-5 py-2.5 transition-colors ${mobile ? "w-full justify-center" : ""}`}
      >
        <LogIn size={16} /> Sign in
      </button>
    );
  }

  const initial = (user.name || user.email || "?").trim()[0]?.toUpperCase() || "?";

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="nav-account"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-2 rounded-full border border-white/20 hover:border-white/50 pl-1.5 pr-3 py-1.5 text-white transition-colors"
      >
        {user.picture ? (
          <img src={user.picture} alt={user.name} className="w-7 h-7 rounded-full object-cover" referrerPolicy="no-referrer" />
        ) : (
          <span className="grid place-items-center w-7 h-7 rounded-full bg-[#DE9A2C] text-[#17120C] text-xs font-bold">{initial}</span>
        )}
        <span className="hidden sm:block text-sm font-medium max-w-[120px] truncate">{user.name?.split(" ")[0] || "Account"}</span>
        <ChevronDown size={14} className="opacity-70" />
      </button>

      {open && (
        <div data-testid="account-menu" className="absolute right-0 mt-2 w-60 rounded-2xl border border-white/10 bg-noir text-white shadow-xl overflow-hidden">
          <div className="px-4 py-3 border-b border-white/10">
            <div className="font-semibold truncate">{user.name || "Signed in"}</div>
            <div className="text-xs text-white/50 truncate">{user.email}</div>
          </div>
          <button
            data-testid="nav-logout"
            onClick={() => { setOpen(false); logout(); }}
            className="w-full flex items-center gap-2 px-4 py-3 text-sm text-white/80 hover:bg-white/5 transition-colors"
          >
            <LogOut size={15} /> Sign out
          </button>
        </div>
      )}
    </div>
  );
};
